export class IdModel {
    id:number;
    ids:number[];
    shipmentStatusId: number = null;
    cols:string;
    shipmentIds: number[];
    isHideInPackage: boolean;
    pageSize: number;
    pageNumber: number;
}